import { ItemLayer } from '.';
import * as marietta from '../..';

export default class UpStairsLayer extends ItemLayer {
  childList: marietta.webcad.item.MonicaObject[]&marietta.webcad.item.parts.UpStair[];

  /**
     * アイテムパーツ作成
     */
  addParts(item) {
    this.spt.addChild(item.spt);

    // アイテム一覧に追加
    this.childList.push(item);
  }

  /**
    * アイテムを削除
    * @param item
    */
  deleteItem(item: marietta.webcad.item.parts.UpStair) {
    let target: marietta.webcad.item.parts.UpStair;
    for (let i: number = this.childList.length - 1; i >= 0; i -= 1) {
      target = this.childList[i] as marietta.webcad.item.parts.UpStair;
      if (target === item) {
        this.childList.splice(i, 1);
        break;
      }
    }
  }

  /**
     * 全てのアイテムの移動
     * @moveX Number X軸移動距離
     * @moveY Number Y軸移動距離
     * */
  // eslint-disable-next-line class-methods-use-this
  moveAllItems(): void {
    // 移動はしない、下階階段とSYNC
  }

  /**
     * 全てのアイテムの移動
     * @moveX Number X軸移動距離
     * @moveY Number Y軸移動距離
     * */
  moveAll(moveX: number, moveY: number): void {
    let target: marietta.webcad.item.parts.UpStair;
    for (let i: number = 0; i < this.childList.length; i += 1) {
      target = this.childList[i] as marietta.webcad.item.parts.UpStair;
      target.move(target.itemInfo.x + moveX, target.itemInfo.y + moveY);
    }
  }
}
